/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
$(document).on("click", ".jsAcd", function () {
  $(`.${$(this).data("target-class")}`).slideToggle();
});
